import { Pipe, PipeTransform } from '@angular/core';
import { fiRegexQuote } from '@fi-shared/utils/regex-quote';

declare const RegExp: any;

@Pipe({
    name: 'highlight',
    standalone: false,
})
export class FiHighlightPipe implements PipeTransform {
    transform(value: any, args?: any): string {
        if (!value || !args) {
            return value;
        }
        return value.replace(new RegExp(fiRegexQuote(args), 'i'), '<b>$&</b>');
    }
}
